import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetUser } from "../api/queries/useGetUser";
import { useAppContext } from "../Context/AppContext";
import { isLoggedIn } from "../auth/authStorage";

function AuthHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = isLoggedIn();
  const { objectId } = useAppContext();

  const [accessToken, setAccessToken] = useState<string | null>(null);
  const accessTokenRef = useRef<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      setAccessToken(token);
      accessTokenRef.current = token;
    }

    const interval = setInterval(() => {
      const updatedToken = localStorage.getItem("access_token");
      if (updatedToken && updatedToken !== accessTokenRef.current) {
        setAccessToken(updatedToken);
        accessTokenRef.current = updatedToken;
      }
      if (!updatedToken && accessTokenRef.current) {
        setAccessToken(null);
        accessTokenRef.current = null;
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const {
    data,
    isSuccess,
    isError,
    error,
    isLoading,
  } = useGetUser({
    id: objectId || "",
    enabled: !!objectId && isAuthenticated && !!accessToken,
  });

  useEffect(() => {
    if (!accessToken || location.pathname !== "/" || isLoading) {
      return;
    }

    const errorMessage =
      (error as any)?.response?.data?.message || (error as any)?.response?.data;

    if (
      isError &&
      (errorMessage === "User does not exist" ||
        errorMessage?.includes("User does not exist"))
    ) {
      navigate("/register-user", { replace: true });
      return;
    }

    if (isSuccess && data) {
      const stripeStatus = data.user.stripeStatus?.toLowerCase?.();
      const isCancelled = stripeStatus === "canceled" || stripeStatus === "cancelled";
      if (isCancelled) {
        navigate("/membership-inactive", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [
    location.pathname,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
    navigate,
    accessToken,
  ]);

  return null;
}

export default AuthHandler;
